import { render, staticRenderFns } from "./ReadTime.vue?vue&type=template&id=29a77af8&"
import script from "./ReadTime.vue?vue&type=script&lang=js&"
export * from "./ReadTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports